// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__NNaVX","additionalNotes":"styles_additionalNotes__1hnA4","registerButton":"styles_registerButton__2nwXg"};